import React from 'react';
import _ from 'lodash';
import { startOfDay } from 'date-fns';
import { toZonedTime, fromZonedTime } from 'date-fns-tz';
import Collection from '../../../utils/Collection';
import TutorCard from '../Card';

const TutorCards = (props) => {
  const { duration, tutors, slotStatuses, onlineStatuses, timeZone } = props;
  const msOfOneDay = 86400000;
  const now = new Date();
  // Get start of day in the specified timezone
  // Convert now to zoned time, get start of day, then convert back to get UTC timestamp
  const zonedNow = toZonedTime(now, timeZone);
  const zonedStartOfDay = startOfDay(zonedNow);
  const utcStartOfDay = fromZonedTime(zonedStartOfDay, timeZone);
  const timestampOfStart = utcStartOfDay.getTime().toString();
  const timestampOfEnd = Number(timestampOfStart) + msOfOneDay * 4;
  const cards = tutors.map((tutor) => {
    const tutorSlotStatus = _.filter(slotStatuses, { tutor_id: tutor.id });
    const onlineStatus = Collection.get(onlineStatuses, tutor.id);
    return (
      <TutorCard
        key={tutor.id}
        tutor={tutor}
        slotStatus={tutorSlotStatus}
        timestampOfStart={timestampOfStart}
        timestampOfEnd={timestampOfEnd}
        duration={duration}
        onlineStatus={onlineStatus}
      />
    );
  });
  return (
    <div className="tutor-cards-section mt-4">
      <div className="tutor-cards">
        <div className="grid grid-cols-12 gap-4">{cards}</div>
      </div>
    </div>
  );
};

export default TutorCards;
